import vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios'
import i18n from '@/i18n';

import promise from 'es6-promise';
promise.polyfill();

vue.use(Vuex);

/*
* 用户打开子页面 的tab 数据 和 操作
* */
const componentList = {
  state: {
    componentTabList: [],
    currentComponentId: null,
    closeCallBack: {},//关闭回调
  },
  getters: {
    getTabList: function (state) {
      return state.componentTabList;
    }
  },
  mutations: {
    //初始化 组件 数据，当页面刷新的时候
    initComponentTabList: function (state) {
      if (!!sessionStorage.getItem('componentTabList')) {
        state.componentTabList = JSON.parse(sessionStorage.getItem('componentTabList'));

        for (var i = 0; i < state.componentTabList.length; i++) {
          if (state.componentTabList[i].currentTab) {
            state.currentComponentId = state.componentTabList[i].componentId;
          }
        }

        setTimeout(function () {
          baseData.state.hotKeyPointer = state.currentComponentId;
        });

      } else {
        state.componentTabList = [{
          componentName: "home",// 组件的 component name，用来动态加载组件
          componentId: "0",// 组件的 id
          componentValue: "<i class='fa fa-credit-card' style='color: #000000;' aria-hidden='true'></i><span style='padding: 0 10px'>" + i18n.t('store.workbench') + "</span>",//组件的名字
          deleteDisable: false,//这个菜单是否可以删除
          currentTab: true//是不是当前组件
        }];

        state.currentComponentId = 0;
      }
    },
    /*点击菜单，添加 一个 菜单项数据到 vuex 的 componentList 仓库中*/
    addComponent: function (state, componentData) {

      if (state.componentTabList.length > 10) {
        let dialogData = {
          dialogDisplayContent: i18n.t('store.tooManyTabs'),
          buttonOne: {
            value: i18n.t('common.buttons.confirm')
          }
        };
        store.dispatch("dialogOpen", dialogData);
        return false;

      }

      var newComponentId = componentData.id;

      //遍历是否存在 相同 id 的组件 tab，如果已经有了，那么在id 后面追加一个时间戳
      for (var i = 0; i < state.componentTabList.length; i++) {
        var tempData = state.componentTabList[i];
        if (componentData.id == tempData.componentId) {
          newComponentId = componentData.id + "*" + new Date().valueOf();
        }
      }

      //所有页面 设置为不是当前页面
      for (var i = 0; i < state.componentTabList.length; i++) {
        state.componentTabList[i].currentTab = false;
      }

      let tempData1 = componentData.componentData ? componentData.componentData : {};
      tempData1.componentName = componentData.component;
      tempData1.newComponentId = newComponentId;
      tempData1.componentValue = componentData.componentName;

      state.componentTabList.push({
        componentData: tempData1,
        componentName: componentData.component,
        componentId: newComponentId,
        componentValue: componentData.componentName,
        deleteDisable: true,
        currentTab: true//新添加的页面设置为当前页面
      });

      state.currentComponentId = newComponentId;
      baseData.state.hotKeyPointer = newComponentId;

      sessionStorage.setItem('componentTabList', JSON.stringify(state.componentTabList));

    },
    //清空所有 tab list 只留下  主页这个不可删除的组件
    emptyComponentList: function (state) {
      let tempArray = [];
      for (var i = 0; i < state.componentTabList.length; i++) {
        var tempData = state.componentTabList[i];
        if (!tempData.deleteDisable) {
          tempArray.push(tempData);
        }
      }


      state.componentTabList = tempArray;

      state.componentTabList[0].currentTab = true;
      state.currentComponentId = 0;
      baseData.state.hotKeyPointer = "0";

      sessionStorage.setItem('componentTabList', JSON.stringify(state.componentTabList));

    },
    //改变当前的 选项卡
    changeCurrentTab: function (state, componentData) {

      for (var i = 0; i < state.componentTabList.length; i++) {
        var tempData = state.componentTabList[i];
        if (componentData.componentId == tempData.componentId) {
          state.componentTabList[i].currentTab = true;
          state.currentComponentId = componentData.componentId;
          //切换页面修改 热键作用域 指针
          baseData.state.hotKeyPointer = componentData.componentId;
        } else {
          state.componentTabList[i].currentTab = false;
        }
      }

      sessionStorage.setItem('componentTabList', JSON.stringify(state.componentTabList));
    },
    //删除一个 tab 选项卡
    deleteOneComponent: function (state, componentId) {
      for (var i = 0; i < state.componentTabList.length; i++) {
        var tempData = state.componentTabList[i];
        if (componentId == tempData.componentId) {
          if (state.componentTabList[i].currentTab) {
            state.componentTabList[i - 1].currentTab = true;
            state.currentComponentId = componentId;
          }
          state.componentTabList.splice(i, 1);
          break;
        }
      }


      if (state.closeCallBack[componentId] && typeof state.closeCallBack[componentId] == "function") {
        state.closeCallBack[componentId]();
      }

      sessionStorage.setItem('componentTabList', JSON.stringify(state.componentTabList));
    },
    //修改 关闭回调 对象
    modifyCloseCallBackF: function (state, data) {
      state.closeCallBack[data.componentId] = data.callBackF;
    }
  }
};
/*dialog 的 vuex 数据 和操作
* */
const dialogData = {
  state: {
    dialogObj: {
      dialogShow: false,//弹窗显示
      shadeShow: false,//弹窗后面 半透明遮罩显示
      dialogHead: i18n.t('common.titles.message'),//dialog 弹窗头部信息  警告、错误、消息。如果没有定义这个字段 默认为   消息
      dialogDisplayContent: "",//dialog 的内容显示
      buttonOne: {//dialog 第一个button 显示
        value: "",
        callBackF: Function
      },
      buttonTwo: {// dialog 第二个 button 显示
        value: "",
        callBackF: Function
      }
    },
    loadImgShow: false,//load动画是否显示
  },
  mutations: {
    openDialog: function (state) {
      state.dialogObj.dialogShow = true;
    },
    closeDialog: function (state) {

      state.dialogObj.dialogShow = false;

    },
    openShade: function (state) {
      state.dialogObj.shadeShow = true;
    },
    closeShade: function (state) {
      if (!state.dialogObj.dialogShow) {
        state.dialogObj.shadeShow = false;
      }
    },
    changeDialogHeadText: function (state, dialogHead) {
      state.dialogObj.dialogHead = dialogHead;
    },
    //修改 现实的 content
    changeDialogContent: function (state, dialogDisplayContent) {
      state.dialogObj.dialogDisplayContent = dialogDisplayContent;
    },
    // 修改button one 的 value 和 回调
    changeButtonOne: function (state, buttonOne) {
      if (buttonOne.value) {
        state.dialogObj.buttonOne.value = buttonOne.value
      }
      if (buttonOne.callBackF) {
        state.dialogObj.buttonOne.callBackF = buttonOne.callBackF
      }
    },
    // 修改button two 的 value 和 回调
    changeButtonTwo: function (state, buttonTwo) {
      if (buttonTwo.value) {
        state.dialogObj.buttonTwo.value = buttonTwo.value
      }
      if (buttonTwo.callBackF) {
        state.dialogObj.buttonTwo.callBackF = buttonTwo.callBackF
      }
    },
    //执行 button one 的按钮回调
    buttonOneCallBack: function (state) {
      state.dialogObj.buttonOne.callBackF();
    },
    //执行 button two 的按钮回调
    buttonTwoCallBack: function (state) {
      state.dialogObj.buttonTwo.callBackF();
    },
    // 还原会 数据的原有样子
    initDialogData: function (state) {
      state.dialogObj = {
        dialogShow: false,//弹窗显示
        shadeShow: false,//弹窗后面 半透明遮罩显示
        dialogHead: i18n.t('store.info'),//dialog 弹窗头部信息
        dialogDisplayContent: "",//dialog 的内容显示
        buttonOne: {//dialog 第一个button 显示
          value: "",
          callBackF: Function
        },
        buttonTwo: {// dialog 第二个 button 显示
          value: "",
          callBackF: Function
        }
      }
    },
    changeLoadImgStatus: function (state, type) {
      state.loadImgShow = type;
    }
  },
  actions: {
    //打开dialog
    dialogOpen: function ({ commit }, { dialogDisplayContent, buttonOne, buttonTwo, dialogHead }) {

      if (dialogHead) {
        commit('changeDialogHeadText');
      }

      if (dialogDisplayContent) {
        commit('changeDialogContent', dialogDisplayContent);
      }
      if (buttonOne) {
        commit('changeButtonOne', buttonOne);
      }
      if (buttonTwo) {
        commit('changeButtonTwo', buttonTwo);
      }
      commit('openShade');
      commit('openDialog');
    },
    /*
     * 修改 dialog 字段为 隐藏状态，同时 遮罩 修改为 隐藏状态
     * 同时还原 数据为空
     * */
    dialogClose: function ({ commit }) {
      commit('buttonOneCallBack');
      commit('closeDialog');
      commit('closeShade');
      commit('initDialogData');
    },
    //打开遮罩
    shadeOpen: function ({ commit }) {
      commit('closeDialog');
      commit('openShade');
    },
    // 关闭遮罩
    shadeClose: function ({ commit }) {
      commit('closeDialog');
      commit('closeShade');
    },
    //调用button one 的回调
    runButtonOneCallBack: function ({ commit }) {
      commit('buttonOneCallBack');
      commit('closeDialog');
      commit('closeShade');
      commit('initDialogData');
    },
    // 调用 button two 的回调
    runButtonTwoCallBack: function ({ commit }) {
      commit('buttonTwoCallBack');
      commit('closeDialog');
      commit('closeShade');
      commit('initDialogData');
    },
    openLoad: function ({ commit }) {
      commit('changeLoadImgStatus', true);
    },
    closeLoad: function ({ commit }) {
      commit('changeLoadImgStatus', false);
    }
  }
};
/*socket 连接
* */
const socketData = {
  state: {
    socketUrl: "/web/pcsocket/LoginSocket",
    socketStatus: false,
    reconnectTimes: 0,//重连次数
  },
  mutations: {
    changeSocketStatus: function (state, type) {
      state.socketStatus = type;
    },
    //修改重连的次数
    changeReconnectTimes: function (state, number) {
      if (number) {
        state.reconnectTimes = number;
      } else {
        state.reconnectTimes = state.reconnectTimes + 1;
      }
    }
  },
  get: {

  },
  actions: {

  }
};

const baseData = {
  state: {
    // 正式环境
    // loginUrl: "https://gateway.graspishop.com/identitysvc",
    //开发环境
    // loginUrl: "https://gateway-dev.graspishop.com/identitysvc",
    //测试环境
    loginUrl: "https://gateway-test.graspishop.com/identitysvc",
    //灰度环境
    // loginUrl: "https://gateway-gray.graspishop.com/identitysvc",

    imgUrl: "",
    pageSize: 50,//分页操作的 时候 pageSize 大小
    Decimal: 2,//小数位精确位数

    QtyDecimal: 2,//库存精度
    PriceDecimal: 2,//单价精度
    TotalDecimal: 2,//总价精度
    DisDecimal: 2,//折扣精度

    billSetDetail: {},//是否显示库存
    userDetail: {},//操作员权限控制
    interfaceCommunication: 0,//界面之间的通信参数

    hotKeyPointer: "",//热键功能当前作用域指针
  },
  mutations: {
    changeImgUrl: function (state, imgUrl) {
      state.imgUrl = imgUrl;
    },
    changeQtyDecimal: function (state, decimal) {
      state.QtyDecimal = decimal;
    },
    changePriceDecimal: function (state, decimal) {
      state.PriceDecimal = decimal;
    },
    changeTotalDecimal: function (state, decimal) {
      state.TotalDecimal = decimal;
    },
    changeDisDecimal: function (state, decimal) {
      state.DisDecimal = decimal;
    },
    changeShowStock: function (state, data) {
      if (!state.billSetDetail) state.billSetDetail = {};
      state.billSetDetail[data.billtype] = data.data;
    },
    changeInterface: function (state, decimal) {
      state.interfaceCommunication = decimal;
    },
    changeHotKeyPointer: function (state, KeyPointer) {
      state.hotKeyPointer = KeyPointer;
    },
    changeUserDetail: function (state, data) {
      state.userDetail = data;
    }
  },
  getters: {
    imgUrlText: function (state) {
      if (!state.imgUrl) {
        state.imgUrl = sessionStorage.getItem("imgHeadUrl");
      }
      return state.imgUrl;
    }
  },
  actions: {
    modifyHotKeyPointer: function ({ commit }, KeyPointer) {
      console.log(KeyPointer + "--------===")
      commit("changeHotKeyPointer", KeyPointer);
    },
    getDecimal: function ({ commit }) {
      axios({
        method: "POST",
        url: "/apc/other/config/batchread",
        data: ["qty", "price", "total", "discount"],
        forbiddenPretreat: true,
      }).then(function (res) {
        if (res.data.RetCode === 0) {
          $.each(res.data.RetObject, function (idx, item) {
            switch (item.SubName) {
              case "qty":
                commit("changeQtyDecimal", item.SubValue);
                break;
              case "price":
                commit("changePriceDecimal", item.SubValue);
                break;
              case "total":
                commit("changeTotalDecimal", item.SubValue);
                break;
              case "discount":
                commit("changeDisDecimal", item.SubValue);
                break;
            }
          })
        }
      });
    },

    billSet: function ({ commit }, billtype) {
      axios({
        method: "get",
        url: "/apc/other/billset/detail",
        params: {
          billtype: billtype
        },
        forbiddenPretreat: true,
      }).then(function (res) {
        if (res.data.RetCode === 0) {
          commit("changeShowStock", { billtype: billtype, data: res.data.RetObject });
        }
      });
    },

    getUserDetail: function ({ commit }, func) {
      let userInfo = sessionStorage.getItem("userInfo");
      if (!userInfo) {
        return false;
      }
      userInfo = JSON.parse(userInfo);

      axios({
        method: "get",
        url: "/apc/baseinfo/user/detail",
        params: {
          userid: userInfo.UserID
        },
        forbiddenPretreat: true,
      }).then(function (res) {
        if (res.data.RetCode === 0) {
          commit("changeUserDetail", res.data.RetObject);
          if (func) func(res.data.RetObject);
        }
      });
    },
  }
};

// 缓存数据
const cacheData = {
  state: {
    data: {},
    param: {
      "God": {
        url: "/apc/other/sync/goods",
        key: "a",
        totalCount: 0,
        GoodsTag: 0,
        RemoveTag: 0,
      }
    }
  },
  mutations: {
    //缓存商品信息
    getGoodsData: function (state, res) {
      let _this = this,
        type = res["type"],
        key = state.param[type].key,
        param = state.param[type];

      if (!state.data[type]) state.data[type] = {};

      $.each(res.data.RetObject.GoodsList, function (idx, item) {
        //f:是否停用
        if (item["f"]) {
          if (state.data[type].hasOwnProperty(item[key])) {
            param.totalCount--;
            delete (state.data[type][item[key]]);
          }
        }
        else {
          if (!state.data[type].hasOwnProperty(item[key])) param.totalCount++;
          item["e"] = [item["b"], item["c"], item["e"]].join("_");
          state.data[type][item[key]] = item;
        }
      });

      $.each(res.data.RetObject.RemoveList, function (idx, item) {
        if (state.data[type].hasOwnProperty(item)) {
          param.totalCount--;
          delete (state.data[type][item]);
        }
      });

      param.GoodsTag = res.data.RetObject.GoodsTag;
      param.RemoveTag = res.data.RetObject.RemoveTag;
    },
    //清空数据
    clearGodData: function (state) {
      state.data["God"] = [];
      state.param["God"].totalCount = 0;
      state.param["God"].GoodsTag = 0;
      state.param["God"].RemoveTag = 0;
    },
    clearAllData: function () {
      this.commit('clearGodData');
    }
  },
  actions: {
    //缓存数据
    getCacheData: function ({ commit }, type) {
      axios({
        method: "get",
        url: this.state.cacheData.param[type].url,
        params: {
          GoodsTag: this.state.cacheData.param[type].GoodsTag,
          RemoveTag: this.state.cacheData.param[type].RemoveTag
        },
      }).then(function (res) {
        if (res.data && res.data.RetCode === 0) {
          res["type"] = type;
          switch (type) {
            case "God":
              commit('getGoodsData', res);
              break;
          }
        } else {
          console.log("errorMessage: \n", res.data.RetMessage);
        }
      }, function (err) {
        console.log("errorMessage--: \n", err);
      });
    },
  }
};
//弹出层提示消息
const promptMessage = {
  state: {
    messageObj: {
      messageShow: false,//提示消息显示
      messageTime: '1000',//显示时间
      messageContent: i18n.t('store.contentRequired'),//提示消息内容
      messageBackground: "black",//提示框背景颜色
      callback: null,//回调方法
    }
  },
  mutations: {
    messageData: function (state, data) {
      if (data.time) {
        state.messageObj.messageTime = data.time;
      }
      if (data.content) {
        state.messageObj.messageContent = data.content;
      }
      if (data.bg) {
        state.messageObj.messageBackground = data.bg;
      }
      if (data.callback) {
        state.messageObj.callback = data.callback;
      }
      state.messageObj.messageShow = true;
      setTimeout(function () {
        state.messageObj.messageShow = false;

        if (state.messageObj.callback) {
          state.messageObj.callback();
          state.messageObj.callback = null;
        }

      }, state.messageObj.messageTime);
    }
  },
}

const store = new Vuex.Store({
  modules: {
    componentList,
    dialogData,
    baseData,
    socketData,
    cacheData,
    promptMessage,
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/extra/store.js